import { XCircle } from "lucide-react";
import { TableCell } from "../ui/table";

import { TableRow } from "../ui/table";

export const EmptyTablePlaceholder = ({
  colSpan,
  emptyStateMessage,
}: {
  colSpan: number;
  emptyStateMessage: string;
}) => {
  return (
    <TableRow>
      <TableCell colSpan={colSpan} className="text-center">
        <div className="flex flex-col items-center justify-center gap-2">
          <XCircle className="h-7 w-7 text-gray-400" />
          <p className="text-sm text-gray-500">{emptyStateMessage}</p>
        </div>
      </TableCell>
    </TableRow>
  );
};
